import React from "react";
import Complaints from "../modules/Complaint";

export const ComplaintPage = () => {
  return <Complaints/>;
};
